export default "__VITE_ASSET__4dX1ePM7__"